import { render } from "./PasswordConfirm.vue?vue&type=template&id=1e534866"
import script from "./PasswordConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script